import { Icon } from '@frontend/icons';
import { PopoverMenuItem, Text, Truncated, usePopoverMenu } from '@frontend/design-system';

type Props = {
  getItemProps: ReturnType<typeof usePopoverMenu>['getItemProps'];
  onBack: () => void;
  title: string;
};

export const PopoverMenuHeader = ({ onBack, getItemProps, title }: Props) => (
  <PopoverMenuItem
    {...getItemProps({
      index: 0,
      onClick: onBack,
      disableCloseOnSelect: true,
    })}
    trackingId='location-phone-conversation-submenu'
  >
    <Icon name='arrow-right-small' css={{ transform: 'rotate(180deg)' }} />
    <Truncated css={{ fontWeight: 'bold', textAlign: 'left' }} as={Text}>
      {title}
    </Truncated>
  </PopoverMenuItem>
);
